
<template>
  <div class="main-box main-min-height bgffffff" ref="main">
    <div class="table-box">
      <div class="DragBox" @dragstart.stop="onDragstart" @dragenter.stop="onDragenter" @dragend.stop="onDragend" draggable>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Drag',
  data() {
    return {
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    onDragstart(){
    },
    onDragenter(){
    },
    onDragend(){
    },
  }
};
</script>

<style lang="scss" scoped>
.DragBox{
    width: 100%;
    height: 300px;
    border: solid 1px #000;
}
</style>
